/* eslint-disable import/prefer-default-export */
export const jQueryMaskRegexOrEmptyString = /(\([0-9]{3}\) [0-9]{3}-[0-9]{4})|^$/;
export const urlRegex =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const loginBaseUrl = window?.location?.origin
  ? `${window.location.origin}/login`
  : 'https://app.gusto.com/login';
